import { ChatCircleIcon as PhosphorChatCircleIcon } from "@phosphor-icons/react/dist/ssr/ChatCircle";

import { createAppIcon } from "@/components/createAppIcon";

export const MessageIcon = /* @__PURE__ */ createAppIcon(PhosphorChatCircleIcon);
